import { useEffect } from 'react'

import { useCurrentRouteMetadata } from '@/Core/Hooks/useCurrentRouteMetadata'
import { resolveRouteTitle } from '@/Ship/Helpers/resolveRouteTitle'

/**
 * Синхронізує назву вкладки браузера з поточним розділом (`pageConfig.title`).
 *
 * Підключається в шаблонах layout-ів Ship. Спрацьовує на кожну зміну маршруту;
 * для сторінок без явної назви і для CRUD-ресурсів нічого не робить — там назву
 * ставить сама сторінка (див. resolveRouteTitle).
 */
export function useRouteDocumentTitle(): void {
    const { title, group, routeInfo } = useCurrentRouteMetadata()
    const resolved = resolveRouteTitle({ title, group, componentName: routeInfo?.componentName })

    useEffect(() => {
        if (resolved) document.title = resolved
    }, [resolved, routeInfo?.path])
}
